import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { flipIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { UserProfilePopupComponent } from "src/app/components/user-profile-popup/user-profile-popup.component";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { HeaderComponent } from "../../../../components/header/header.component";
import { DotFlashAnimationComponent } from "../../../../components/dot-flash-animation/dot-flash-animation.component";
import { NgClass } from "@angular/common";
import { DisplayCurrencyPipe } from "../../../../pipe/display-currency.pipe";
import { InProgressAnimationComponent } from "../../../../components/in-progress-animation/in-progress-animation.component";

@Component({
    selector: "app-checked-managed-ticket",
    templateUrl: "./checked-managed-ticket.component.html",
    styleUrls: ["./checked-managed-ticket.component.scss"],
    animations: [flipIn],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        SwiperModule,
        DotFlashAnimationComponent,
        NgClass,
        InProgressAnimationComponent,
        DisplayCurrencyPipe,
        TranslatePipe],
})
export class CheckedManagedTicketComponent implements OnInit {
  @ViewChild("swiperRef", { static: false }) swiperSlider?: SwiperComponent;
  public isEmptyTicket: boolean;
  navigationSpeed: number;
  ticketSliderOptions: SwiperOptions = {
    speed: 400,
    initialSlide: 0,
    centeredSlides: true,
    slidesPerView: 1.15,
    pagination: {
      el: ".swiper_pager",
      clickable: true,
      // dynamicBullets: true
    },
  };
  public showFlip: boolean;
  public showLines: boolean
  public dotAnimation: boolean;
  public viewText: boolean;
  public flip: boolean;
  public wasCardClicked: boolean
  breakdownInfo: Data;
  ticketBaseInfo: Data;
  checkedTickets: Data;
  syndicate_size = null;
  public index: number;
  matchedNumbers: Data = {};
  isHighlighted: boolean;
  translatedToastMsg: Data;
  selectedLanguage: string;
  preferredCurrency: string = CommonVariable.preferredCurrency
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  showTooltip: boolean;
  public months: string[];
  public days: string[];
  constructor(
    private modelController: ModalController,
    private navParams: NavParams,
    private syndicateService: SyndicateRepositoryService,
    public translate: TranslateService,
    private authService: AuthService,
    private matDialog: MatDialog,
    private snackService: MySnackBarService,
    private ngZone: NgZone,
  ) {
    this.selectedLanguage = "en";
    this.isHighlighted = false;
    this.index = 0;
    this.wasCardClicked = true;
    this.flip = false;
    this.viewText = true;
    this.showLines = true;
    this.isEmptyTicket = false;
    this.showTooltip = false // set by default false
    this.navigationSpeed = 500;
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        if (l) {
          this.selectedLanguage = l;
          translate.use(l ? l : "en");
          this.getDaysOfWeek();
          this.getMonths();
        }
      },
      (err) => {
        return (err);
      }
    );
    this.authService.getConstantsMsg$.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })

    this.authService.userDetails$.subscribe(
      (user: Data) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$.subscribe((data: Data) => {
          const CurrencyDetails = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      (err) => {
        return err;
      }
    );

    this.breakdownInfo = this.navParams?.data;
    this.syndicateService
      .getCheckedTickets(this.breakdownInfo.id, this.breakdownInfo.checkDate)
      .pipe(
        map((ticketInfos: Data) => {
          if (ticketInfos) {
            if (ticketInfos?.length === 0) {
              this.isEmptyTicket = true;
              return ticketInfos;
              return;
            }
            ticketInfos.map((ticketInfo, i) => {
              ticketInfo.showFlip = false;
              ticketInfo.showLines = true;
              ticketInfo.dotAnimation = false;
              ticketInfo.viewText = true;
              this.breakdownInfo.totalWinAmount = 0;
              if (ticketInfo?.matched_numbers) {
                this.matchedNumbers[i] = ticketInfo?.matched_numbers;
              }
              if (ticketInfo.tickets) {
                ticketInfo?.tickets.map((ticket, index) => {
                  this.breakdownInfo.totalWinAmount = this.breakdownInfo?.totalWinAmount + ticket.win_amount;
                });
              }
            });

            return ticketInfos;
          } else {
            this.isEmptyTicket = true;
          }
          return ticketInfos;
        })
      )
      ?.subscribe(
        (checkedTickets) => {
          if (!checkedTickets) return;
          this.checkedTickets = checkedTickets;
        },
        (err) => {
          return (err)
        }
      );

    this.syndicateService?.getCheckedTicketDetail(this.breakdownInfo?.id)?.subscribe(
      (ticketInfo: Data) => {
        this.ticketBaseInfo = ticketInfo;
      },
      (err) => {
        return (err);
      }
    );
  }

  slideChanged() {
    this.index = this.swiperSlider?.swiperRef?.activeIndex;
  }

  ngOnInit() { }
  showProfilePopup(user_id: string) {
    if (user_id) {
      this.matDialog.open(UserProfilePopupComponent, {
        panelClass: "user-profile-popup",
        // backdropClass: "decline-back-drop-color",
        data: user_id,
        disableClose: false,
      });
    } else {
      /* const msg = this.translatedToastMsg?.["1045"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "There is an issue with profile popup", "Error", ""); */
      this.authService.getConstantsMsg("1045").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "There is an issue with profile popup",
            line_2: "",
          },
          style: {
            type: "error",
            icon: "tick circle error.svg",
          }
        }
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((err) => {
        return err;
      })
    }
  }

  goBack() {
    this.modelController.dismiss().catch((err) => {
      return err;
    });
  }

  switchMode(index) {
    const checkedTicketsCard = document.getElementById("checkedTicketsCard");
    if (!checkedTicketsCard || !checkedTicketsCard?.classList) return;
    if (this.wasCardClicked) {
      checkedTicketsCard?.classList?.add("checkedTicketsCard");
    } else {
      checkedTicketsCard?.classList?.remove("checkedTicketsCard");
    }
    this.wasCardClicked = !this.wasCardClicked;
    if (this.checkedTickets && this.checkedTickets?.[index])
      this.checkedTickets[index].showLines = !this.checkedTickets[index].showLines;
  }

  switchReverse(index) {
    if (!this.checkedTickets || !this.checkedTickets[index]) return;
    setTimeout(() => {
      this.checkedTickets[index].showFlip = false;
      this.checkedTickets[index].showLines = !this.checkedTickets[index].showLines;
      this.checkedTickets[index].showFlip = false;
    }, 400);
    this.checkedTickets[index].showFlip = true;
    this.flip = !this.flip;
  }

  viewPlayers(index) {
    if (!this.checkedTickets || !this.checkedTickets[index]) return;
    const { syndicate_id, syndicate_type } = this.checkedTickets[0];
    this.checkedTickets[index].dotAnimation = true;
    this.syndicateService?.viewPlayersCount({ psId: syndicate_id, cardType: syndicate_type })?.subscribe(
      (res: Data) => {
        if (res && res?.response && res?.response?.status?.toLowerCase() === "success") {
          this.syndicate_size = res?.response?.syndicate_size;
        }
        this.checkedTickets[index].viewText = false;
        this.checkedTickets[index].dotAnimation = false;
      },
      (err) => {
        return (err);
      }
    );
  }

  checkRegularNumber(num, results) {
    if (results.regular.some((e) => e?.num === num)) {
      return true;
    }
    return false;
  }

  checkRegularNumberLN(num, results, ticketIndex, ticketRow) {
    if (results.regular.some((e) => e?.num === num)) {
      if (this.checkMatchedNumber(ticketIndex, ticketRow, num)) {
        this.isHighlighted = true;
        return "blue-cirle-ticket blue-cirle-broder";
      } else return "blue-cirle-ticket";
    }
    return "";
  }

  checkBonusNumber(num, results) {
    if (results.bonus.some((e) => e?.num === num)) {
      return true;
    }
    return false;
  }

  checkMatchedNumber(ticketIndex, ticketRow, ticketNum) {
    if (this.matchedNumbers?.[ticketIndex]?.[ticketRow]?.some((e) => ("0" + e).slice(-2) === ticketNum)) {
      return true;
    }
    return false;
  }
  slidePrev() {
    this.swiperSlider?.swiperRef?.slidePrev(this.navigationSpeed);
  }
  slideNext() {
    this.swiperSlider?.swiperRef?.slideNext(this.navigationSpeed);
  }

  // This method is used to show more raffle tickets on click
  showMoreRaffle() {
    this.showTooltip = this.showTooltip ? false : true;
  }
  getMonths() {
    const translationKeys = [
      'Month_name.January',
      'Month_name.February',
      'Month_name.March',
      'Month_name.April',
      'Month_name.May',
      'Month_name.June',
      'Month_name.July',
      'Month_name.August',
      'Month_name.September',
      'Month_name.October',
      'Month_name.November',
      'Month_name.December'];
    this.translate.get(translationKeys).subscribe((translation: string[]) => {
      this.ngZone.run(() => {
        this.months = translationKeys.map(key => translation[key]);
      });
    })

  }

  translateMonthAbbreviation(dateString: string) {
    const dateParts = (dateString ?? '').split(' '); // Split the date string into parts
    const monthAbbreviation = dateParts[1]; // Get the month abbreviation from the date string
    this.getMonths();
    if (this.months && this.months.length > 0) {
      switch (monthAbbreviation) {
        case "Jan":
          dateParts[1] = this.months[0];
          return dateParts.join(" ");
        case "Feb":
          dateParts[1] = this.months[1];
          return dateParts.join(" ");
        case "Mar":
          dateParts[1] = this.months[2];
          return dateParts.join(" ");
        case "Apr":
          dateParts[1] = this.months[3];
          return dateParts.join(" ");
        case "May":
          dateParts[1] = this.months[4];
          return dateParts.join(" ");
        case "June":
          dateParts[1] = this.months[5];
          return dateParts.join(" ");
        case "July":
          dateParts[1] = this.months[6];
          return dateParts.join(" ");
        case "Aug":
          dateParts[1] = this.months[7];
          return dateParts.join(" ");
        case "Sept":
          dateParts[1] = this.months[8];
          return dateParts.join(" ");
        case "Oct":
          dateParts[1] = this.months[9];
          return dateParts.join(" ");
        case "Nov":
          dateParts[1] = this.months[10];
          return dateParts.join(" ");
        case "Dec":
          dateParts[1] = this.months[11];
          return dateParts.join(" ");
      }
    } else {
      return dateParts.join(" ");
    }
  }
  getDaysOfWeek() {
    const translationKeys = [
      'week_name.sunday',
      'week_name.monday',
      'week_name.tuesday',
      'week_name.wednesday',
      'week_name.thursday',
      'week_name.friday',
      'week_name.saturday'
    ];
    this.translate.get(translationKeys).subscribe((translations: string[]) => {
      this.days = translationKeys.map(key => translations[key]);
    });
  }
  
  translateDayAbbreviation(dayAbbreviation) {
    this.getDaysOfWeek();
    if(this.days){
      const dayMap = {
        'Sun': 0,
        'Mon': 1,
        'Tue': 2,
        'Wed': 3,
        'Thu': 4,
        'Fri': 5,
        'Sat': 6
      };
    
      if (dayAbbreviation && dayAbbreviation.product_draw_day && dayMap.hasOwnProperty(dayAbbreviation.product_draw_day)) {
        return this.days[dayMap[dayAbbreviation.product_draw_day]];
      }
    }
    else{
      return dayAbbreviation.product_draw_day;
    }
  }
}
